var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMapMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91492 4.77636C7.91492 5.36158 7.69702 6.06952 7.32027 6.83785C6.94799 7.59705 6.44508 8.36645 5.93144 9.06129C5.41917 9.75426 4.90493 10.3614 4.51721 10.7954C4.43877 10.8832 4.36568 10.9637 4.29902 11.0362C4.22991 10.9608 4.15385 10.8768 4.07208 10.785C3.67987 10.3447 3.16032 9.72997 2.64448 9.0319C2.12716 8.33181 1.62275 7.56017 1.25322 6.80511C0.878483 6.0394 0.670424 5.34649 0.681365 4.78817C0.722286 2.69983 2.32481 1.05596 4.2982 1.05596C6.28195 1.05596 7.91492 2.70776 7.91492 4.77636Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.20566
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapMarker);
export default __webpack_public_path__ + "static/media/icon-map-marker.6b094b5ae8a27eed4c6e087c5e4ddc3c.svg";
export { ForwardRef as ReactComponent };